import styled from "styled-components";

/* PAGE */
export const PageWrapper = styled.div`
    min-height: 100vh;
    padding: 0.5rem;
    background-color: #eae7f6;
    box-sizing: border-box;

    @media screen and (min-width: 768px) {
        padding: 3rem;
    }
`;

/* TITLE */
export const PageTitle = styled.h1`
    font-size: 2.6rem;
    font-weight: 800;
    text-align: center;
    margin-bottom: 3rem;
    color: #1D2126;


    @media screen and (min-width: 768px) {
        font-size: 3rem;
    }
`;

/* SHEET */
export const SheetWrapper = styled.div`
    display: flex;
    flex-direction: column;

`;

/* ROW */
export const Row = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    justify-content: space-around;
    gap: 0.5rem;

    @media screen and (min-width: 1000px) {
        flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
    }
`;


/* IMAGE */
export const ImageWrapper = styled.div`
    width: 100%;
    max-width: 40rem;
    flex-shrink: 0;
    border-radius: 0.75rem;
    overflow: hidden;
    box-shadow: 0px 8px 31px rgba(0, 0, 0, 0.15);
`;

export const Image = styled.img`
    width: 100%;
    height: 26rem;
    object-fit: cover;
`;

/* TEXT */
export const TextCard = styled.div`
    flex: 1;
    max-width: 38rem;
    width: 100%;
    padding: 1.5rem;
    //background-color: #ffffff;
    border-radius: 0.75rem;
    //box-shadow: 0px 8px 31px rgba(0, 0, 0, 0.15);
`;

export const TextLines = styled.div`
    display: flex;
    flex-direction: column;
    gap: -0.5rem;
`;

export const TextLine = styled.div`
    color: #374151;
    line-height: 1.6;
    font-size: 1rem;
    padding: 0;
    margin: 0;
`;
